import { Background, Container } from './styles';

const SignUp = (): JSX.Element => {
  return (
    <Container>
      <Background />
    </Container>
  );
};

export default SignUp;
